/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import { connect } from 'react-redux';
import BookDetails from './BookDetails';
import {getBookDetails,getCollectionNotes,saveNotes} from "../../../_thunks/bookdetails.thunk";
import {getFrontCoverPageDetails} from "../../../_thunks/cover.thunk";
import {changeTocNumeration,changeAccessCodeRequested,changeChapterHeaders,changeForcedTrimSize,changeTrimSize} from "../../../_actions/bookdetails.actions";
import {changeCollecitonTitle,changeCollecitonTrimSize} from "../../../_actions/collection.actions";
//import { fetchFrontCoverImages, updateFrontCoverImage } from '../../../_thunks/book.thunk';
import  {getOverridePrice, updateOverridePrice} from "../../../_thunks/price.thunk";
import {showAlert, hideAlert} from "../../../_actions/alert.actions";
import {hideModal} from "../../../_actions/modal.actions";

function mapStateToProps(state, props) {
    return {
        activeCollection: state.activeCollection,
        printTOCChapterType: state.bookdetailsreducer.printTOCChapterType,
        forcedTrimSize: state.bookdetailsreducer.forcedTrimSize,
        automaticPageNumbering: state.bookdetailsreducer.automaticPageNumbering,
        automaticIndexes: state.bookdetailsreducer.automaticIndexes,
        chapterHeaders: state.bookdetailsreducer.chapterHeaders,
        forcedRectoStart: state.bookdetailsreducer.forcedRectoStart,
        thumbnailUrl: state.bookdetailsreducer.thumbnailUrl,
        accessCodeRequested: state.bookdetailsreducer.accessCodeRequested,
        pageCount: state.bookdetailsreducer.pageCount,
        match: props.match,
        setupAccessCode: state.accessCodeSetup.setupAccessCode,
        collectionNotes: state.collectionNotesReducer.collectionNotes,
        frontCoverurl:state.bookdetailsreducer.frontCoverurl,
        etextStatuses: state.etextStatuses,
        vitalsourceStatuses: state.vitalsourceStatuses,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getFrontCoverImages: collectionId => {
            dispatch(fetchFrontCoverImages(collectionId));
        },
        changeFrontCoverImage: (collectionId, coverImageId) => {
            dispatch(updateFrontCoverImage(collectionId, coverImageId));
        },
        getEtextStatuses : (collectionId) => {
            dispatch(getEtextPublishStatuses(collectionId));
            dispatch(getEtextOptimizeStatuses(collectionId));
        },
        getvitalsourceStatusLog : (collectionId) => {
            dispatch(getVitalsourcePublishStatuses(collectionId));
        },
        getBookDetailsInfo : (collectionId) => {
            dispatch(getBookDetails(collectionId));
        },
        getFrontCoverPage : (collectionId) => {
            dispatch(getFrontCoverPageDetails(collectionId));
        },
        updateCollectionTitle: (title) => {
            dispatch(changeCollecitonTitle(title));
        },
        updateTOCNumeration: (tocNumeration) => {
            dispatch(changeTocNumeration(tocNumeration));
        },
        updateForcedTrimSize: (forcedTrimSize) => {
            dispatch(changeForcedTrimSize(forcedTrimSize));
        },
        updateChapterHeaders: (chapterHeaders) => {
            dispatch(changeChapterHeaders(chapterHeaders));
        },
        updateAccessCode: (accessCodeRequested) => {
            dispatch(changeAccessCodeRequested(accessCodeRequested));
        },
        updateTrimSize: (trimSize) => {
            dispatch(changeCollecitonTrimSize(trimSize));
            dispatch(changeTrimSize(trimSize));
        },
        getOverridePrice : (collectionId) => {
            return dispatch(getOverridePrice(collectionId));
        },
        updateOverridePrice : (params) => {
            return dispatch(updateOverridePrice(params));
        },
        getNotesWithHolds: (collectionId) => {
            dispatch(getCollectionNotes(collectionId));
        },
        saveNotesWithHolds: (params) => {
            dispatch(saveNotes(params));
        },
        showOM3PAlert: (hasOM, has3P) => {
            if (hasOM && has3P) {
                dispatch(showAlert({messageKey: 'book_has_both_om_and_3p' }));
            } else if (hasOM) {
                dispatch(showAlert({messageKey: 'book_has_om' }));
            }
            else if (has3P) {
                dispatch(showAlert({messageKey: 'book_has_3p', autoHide: false }));
            }
        },
        hideOM3PAlert: () => {
            dispatch(hideAlert());
        },
        closeModal : () => {
            dispatch(hideModal());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BookDetails);


// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookDetailsLink.js